import { DbRef } from '@caresend/types';
import { getPath } from './path.js';
import { formatCentsToDollar } from '../formatters/currency.js';

/**
 * ```
 * `${DbRef.ITINERARIES}/${id}/${childPath}`
 * ```
 */

function getItineraryPath(id, childPath) {
  return getPath(`${DbRef.ITINERARIES}/${id}`, childPath);
}
/** in US cents */

const getItineraryNurseEarnings = itinerary => itinerary.baseNurseEarnings;
/** Example: '$150' */

const getFormattedItineraryNurseEarnings = itinerary => {
  const earnings = getItineraryNurseEarnings(itinerary);
  return formatCentsToDollar(earnings);
};

export { getFormattedItineraryNurseEarnings, getItineraryNurseEarnings, getItineraryPath };
